import React, { useState } from 'react'
import {useCookies} from "react-cookie";
import UserList from "./UserList";
import EditUsername from "./EditUsername";

const UserListParent = ({socket, showUserList, hideUserList}) => {

    const [cookies, setCookie, removeCookie] = useCookies(["rave_username"]);
    const [users, setUsers] = useState({});
    const [showEditScreen, setShowEditScreen] = useState(false);


    const onEditClick = () => {
        hideUserList();
        setShowEditScreen(true);
    }

    const onUpdateCookie = (username) => {
        if(username && username !== '') {
            setCookie('rave_username', username, {maxAge: 15778800});
            console.log('Setting username as: '+ username);
        } else {
            removeCookie('rave_username');
            console.log('Removing cookie: username');
        }

    }

    const closeEdit = () => {
        setShowEditScreen(false);
    }

    if (socket !=null) {
        socket.on('updateUsernameList', (res) => {setUsers(res)});
    }

    return (
        <>
            {showUserList && <UserList users={users} onEditClick={onEditClick} cookies={cookies}/>}
            {showEditScreen && <EditUsername socket={socket} onClose={closeEdit} onUpdateCookie={onUpdateCookie}/>}
        </>

    )
}

export default UserListParent;